import React, { Fragment } from "react";
import GenericHeader from "../../common/Header";

class HeaderLayout extends React.Component {
  state = {};
  constructor() {
    super();

    this.headerLayout = [
      {
        label: {
          value: "Vendor",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vendor",
          onBlur: "lookup",
          onFocus: "selectEndPoint",
          hotMod: false
        },
        size: "10%"
      },
      {
        label: {
          value: "Vendor Name",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          onFocus: "selectEndPoint",
          onBlur: "lookup",
          hotMod: false,
          value: "",
          intemName: "vendName"
        },
        size: "40%"
      }
    ];
  }
  componentDidMount() {
    this.setState({ layout: this.headerLayout });
  }

  formatData = props => {
    if (props) {
      this.headerLayout.map((layout, key) => {
        if (layout.item.intemName === props[key].name) {
          layout.item.value =
            props[key].value === undefined ||
            props[key].value === "" ||
            props[key].value === false
              ? ""
              : props[key].value;
          layout.item.obj = props[key].obj;
          layout.item.span = props[key].span;
          layout.label.value = props[key].label;
        }
        return null;
      });
    }

    return null;
  };
  getHeaderInfo = info => {
    this.props.setHeaderInfo({ header: info });
  };
  renderHeader = () => {
    this.formatData(this.props.headerData);
    return (
      <GenericHeader
        jsonObj={this.state.layout}
        setHeaderInfo={this.getHeaderInfo}
        functions={{
          lookup: this.props.lookup,
          selectEndPoint: this.props.selectEndPoint,
          setErrorMessage: this.props.setErrorMessage,
          setSuccessMessage: this.props.setSuccessMessage
        }}
      />
    );
  };
  render() {
    return <Fragment>{this.renderHeader()}</Fragment>;
  }
}
export default HeaderLayout;
